import { Navigate, useParams } from "react-router-dom";
import { useAuthContext } from "../hooks/Auth";

interface ProtectedAuditoriaRouteProps {
  Component: React.ElementType;
  Wrapper?: React.ElementType;
}

const ProtectedAuditoriaRoute = ({
  Component,
  Wrapper,
}: ProtectedAuditoriaRouteProps) => {
  const { user } = useAuthContext();
  const { tipoAuditoria, orgOrPais, idPaisOrOrg } = useParams();

  // En caso de que el tipoAuditoria no sea "eventos" o "sublimacion", salimos
  if (tipoAuditoria !== "eventos" && tipoAuditoria !== "sublimacion") {
    return <Navigate to="/asistente/menu" replace />;
  }

  // En caso de que el orgOrPais no sea "organizacion" o "pais", salimos
  if (orgOrPais !== "organizacion" && orgOrPais !== "pais") {
    return <Navigate to="/asistente/menu" replace />;
  }

  // En caso de que NO sea un Admin de Dominio, verificamos que el usuario haga parte de la organizacion
  const isNotSuperAdmin = !user?.roles.some(
    (rol) => rol.rol === "Admin de Dominio"
  );

  if (isNotSuperAdmin) {

    // Verificamos que no sea la pagina "pais"
    const paisPage = orgOrPais === "pais"

    // Verificar si el usuario puede acceder a esa organizacion
    const canAccess = user?.id_organizacion === idPaisOrOrg;
    console.log(canAccess);

    /* Sino, se redirige */
    if (!canAccess || paisPage) {
      return <Navigate to="/asistente/menu" replace />;
    }
  }

  // Si hay un Wrapper, lo usamos para envolver el componente
  return Wrapper ? (
    <Wrapper>
      <Component />
    </Wrapper>
  ) : (
    <Component />
  );
};

export default ProtectedAuditoriaRoute;
